import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Color } from '@app/models';
import { environment } from '@environments/environment';

const API = environment.API;

@Injectable({
  providedIn: 'root'
})
export class ColorService {
  constructor(private http: HttpClient) {}

  get(FollowId: number) {
    return this.http.get<Color[]>(`${API}/follows/${FollowId}/colors`);
  }

  update(followId: number, data: any) {
    return this.http.put<Color>(
      `${API}follows/${followId}/colors/${data.id}`,
      data
    );
  }
  
  delete(idColor: number, followId: number) {
    return this.http.put<Color>(`${API}follows/${followId}/colors/delete/${idColor}`,{"IdColor":idColor});
  }

  create(FollowId: number, color: Color) {
    return this.http.post<Color>(`${API}/follows/${FollowId}/colors`, color);
  }
}
